module.exports = __webpack_public_path__ + "img/home2.d9c054f9.jpg";